import Accordion from "./Accordion";

class Map {
    mapSelector = '.map';
    mapEl = null;
    hotspotSelector = '.hotspot';
    hotspotEls = null;
    hotspotActiveClass = 'map__hotspot--active';
    hotspotActiveClassLeftSide = 'map__hotspot--active-left-side';
    hotspotActiveClassRightSide = 'map__hotspot--active-right-side';
    hotspotActiveEl = null;
    bodyEl = null;
    activeMobileHotspotEl = null;


    constructor(mapSelector = null, hotspotSelector = null) {
        this.mapSelector = mapSelector ?? this.mapSelector;
        this.hotspotSelector = hotspotSelector ?? this.hotspotSelector;
        this.mapEl = document.querySelector(this.mapSelector);
        if (this.mapEl) {
            this.hotspotEls = this.mapEl.querySelectorAll(this.hotspotSelector);
        }
        this.bodyEl = document.querySelector('body');
    }

    overrideHotspotActiveClass(hotspotActiveClass) {
        this.hotspotActiveClass = hotspotActiveClass;
    }

    overrideHotspotActiveClassLeftSide(hotspotActiveClassLeftSide) {
        this.hotspotActiveClassLeftSide = hotspotActiveClassLeftSide;
    }

    overrideHotspotActiveClassRightSide(hotspotActiveClassRightSide) {
        this.hotspotActiveClassRightSide = hotspotActiveClassRightSide;
    }

    deactivateOtherHotspots(hotspotEl) {
        if (hotspotEl) {
            hotspotEl.classList.remove(this.hotspotActiveClass);
            hotspotEl.classList.remove(this.hotspotActiveClassLeftSide);
            hotspotEl.classList.remove(this.hotspotActiveClassRightSide);
            this.hotspotActiveEl = null;
        }

        // removing z-index inline style from other hotspots
        this.hotspotEls.forEach(hotspot => {
            this.resetHotspotZIndex(hotspot)
        });
    }

    resetHotspotZIndex(hotspotEl) {
        try {
            hotspotEl.parentElement.style.zIndex = '';
        } catch (e) {
            // do nothing
        }
    }

    getMapWidth() {
        return this.mapEl.offsetWidth;
    }

    getHotspotPosition(hotspotEl) {
        return hotspotEl.offsetLeft;
    }

    addBodyOverlay() {
        this.bodyEl.classList.add('map-active');
    }

    removeBodyOverlay() {
        this.bodyEl.classList.remove('map-active');
    }

    getOtherHotspots(hotspotEl) {
        return Array.from(this.hotspotEls).filter(hotspot => hotspot !== hotspotEl);
    }

    sendOtherHotspotsToBack(hotspotEl) {
        this.getOtherHotspots(hotspotEl).forEach(hotspot => {
            try {
                hotspot.parentElement.style.zIndex = 0;
            } catch (e) {
                // do nothing
            }
        });
    }

    getHotspotPositionAsPercentage(hotspotEl) {
        try {
            const leftPercentage = hotspotEl.parentElement.style.left;
            return parseInt(leftPercentage);
        } catch (e) {
            return 0;
        }
    }

    isHotspotOnLeftSide(hotspotEl) {
        // getting the left attribute of the hotspot
        return this.getHotspotPositionAsPercentage(hotspotEl) <= 50;
    }

    activateHotspotOnMobile(hotspotEl) {
        // copy to desktop
        this.activeMobileHotspotEl = null; // reset mobile hotspot

        // copying modal content to the document body
        const hotspotModal = hotspotEl.parentElement;
        const hotspotModalCopy = hotspotModal.cloneNode(true);

        // applying mobile class and adding to the DOM
        hotspotModalCopy.classList.add('hotspot--mobile');
        hotspotModalCopy.style.top = "";
        hotspotModalCopy.style.left = "";
        document.body.appendChild(hotspotModalCopy);

        // activiating the hotspot
        const clonedHotspotEl = hotspotModalCopy.querySelector(this.hotspotSelector);
        clonedHotspotEl.classList.add(this.hotspotActiveClass);

        // close button init
        this.initCloseBtn(clonedHotspotEl);

        // applying the mobile el
        this.activeMobileHotspotEl = hotspotModalCopy;

        (hotspotModalCopy.querySelectorAll('.hotspot__content') || []).forEach((accordion) => new Accordion(accordion, 'click'));
    }

    activateHotspot(hotspotEl) {
        // if we are on mobile then copy the hotspot content to the document body
        if (window.innerWidth <= 992) {
            this.activateHotspotOnMobile(hotspotEl);
        }

        // adding class to the clicked hotspot
        hotspotEl.classList.add(this.hotspotActiveClass);
        // adding class to the map to indicate the active hotspot is on the left side
        if (this.isHotspotOnLeftSide(hotspotEl)) {
            hotspotEl.classList.add(this.hotspotActiveClassLeftSide);
        } else {
            hotspotEl.classList.add(this.hotspotActiveClassRightSide);
        }
        // setting the clicked hotspot as the active hotspot
        this.hotspotActiveEl = hotspotEl;
        this.sendOtherHotspotsToBack(hotspotEl);
    }

    hotspotClickEvent(e) {
        // deactivating other hotspots
        this.deactivateOtherHotspots(this.hotspotActiveEl);
        // activating the clicked hotspot
        this.activateHotspot(e.currentTarget);
        this.addBodyOverlay();
    }

    outsideClicked(e) {
        if ((this.hotspotActiveEl && !this.hotspotActiveEl.contains(e.target))
          || (this.activeMobileHotspotEl && !this.activeMobileHotspotEl.contains(e.target))) {
            this.removeBodyOverlay();
            this.deactivateOtherHotspots(this.hotspotActiveEl);
            this.closeMobileHotspots();
        }
    }

    initOutsideClick() {
        document.addEventListener('click', e => {
            try {
                const desktopHotspotClicked = this.hotspotActiveEl && this.hotspotActiveEl.parentElement.contains(e.target);
                const mobileHotspotClicked = this.activeMobileHotspotEl && this.activeMobileHotspotEl.contains(e.target);
                if (!desktopHotspotClicked && !mobileHotspotClicked) {
                    this.outsideClicked(e);
                }
            } catch (e) {
                this.outsideClicked(e);
            }
        });
    }

    closeHotspotEvent(e) {
        e.stopPropagation();
        this.removeBodyOverlay();
        this.deactivateOtherHotspots(this.hotspotActiveEl);
        this.closeMobileHotspots();
    }

    closeMobileHotspots() {
        this.deactivateOtherHotspots(this.activeMobileHotspotEl);
        this.activeMobileHotspotEl.remove();
        this.activeMobileHotspotEl = null;
    }

    initCloseBtn(hotspotEl) {
        const closeEl = hotspotEl.parentElement.querySelector('.close');
        if (closeEl) {
            closeEl.addEventListener('click', this.closeHotspotEvent.bind(this), false);
        }
    }

    initHotspots() {
        Array.from(this.hotspotEls).forEach(hotspotEl => {
            this.initCloseBtn(hotspotEl);
           hotspotEl.addEventListener('click', this.hotspotClickEvent.bind(this), false);
        });
    }

    init() {
        if (this.mapEl && this.hotspotEls) {
            this.initHotspots();
            this.initOutsideClick();
        }
    }
}

export default Map;
